import * as Audio from "./audio";
import * as Animation from "./animation";
import * as Camera from "./camera";
import * as Engine from "./engine";
import * as Environment from "./environment";
import * as Lighting from "./lighting";

import { Color4, DracoCompression, Scene } from "babylonjs";

import store from "./store";

export const useCanvas = (canvas: HTMLCanvasElement) => {
  store.canvas = canvas;

  // Load the 3D engine
  Engine.create();

  // Create a basic BJS Scene object
  store.scene = new Scene(store.engine);
  store.scene.clearColor = new Color4(0, 0, 0, 0);
  // store.scene.debugLayer.show();

  dracoConfig();

  Lighting.create();
  Camera.create();

  // Initialization complete.
  awake();
  start();
};

export const disposeCanvas = () => {
  //console.log(store.scene);
  if (store.scene) {
    store.scene.dispose();
  }

  Animation.setAnimating(false);
};

function awake() {
  Engine.awake();
  Audio.awake();
}

function start() {
  Environment.create();
}

function dracoConfig() {
  DracoCompression.Configuration = {
    decoder: {
      wasmUrl:
        "https://www.gstatic.com/draco/v1/decoders/draco_decoder_gltf.js",
      wasmBinaryUrl:
        "https://www.gstatic.com/draco/v1/decoders/draco_decoder_gltf.wasm",
      fallbackUrl:
        "https://www.gstatic.com/draco/v1/decoders/draco_wasm_wrapper_gltf.js",
    },
  };
}
